import { render } from "./VirtualPackingSlipShipmentDetails.vue?vue&type=template&id=2ed8316e&scoped=true"
import script from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js"
export * from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js"

import "./VirtualPackingSlipShipmentDetails.vue?vue&type=style&index=0&id=2ed8316e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed8316e"]])

export default __exports__